import { api } from '@forbiz/web-kit'
import type {
  CreateSenderPresetRequest,
  SenderPresetListResponse,
  SenderPresetResponse,
  UpdateSenderPresetRequest,
} from '@forbiz/contracts'

/**
 * 발신자 문구 프리셋 API 클라이언트 (BIZ-43).
 * 목록은 기업 담당자도, 등록·수정·삭제는 기업 관리자만(서버가 최종 판정).
 */
export const senderPresetsApi = {
  list: () => api.get<SenderPresetListResponse>('/api/sender-presets'),
  create: (body: CreateSenderPresetRequest) =>
    api.post<{ preset: SenderPresetResponse }>('/api/sender-presets', body),
  update: (id: number, body: UpdateSenderPresetRequest) =>
    api.put<{ preset: SenderPresetResponse }>(`/api/sender-presets/${id}`, body),
  remove: (id: number) => api.del<{ ok: true }>(`/api/sender-presets/${id}`),
}
